import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
} from "@chakra-ui/react";
import React from "react";
import { ReferrerForm } from "../molecules/ReferrerForm";

export function ReferrerModal({ isOpen, onClose }) {
  return (
    <Modal
      closeOnOverlayClick={true}
      closeOnEsc={true}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Indique um Cliente</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <ReferrerForm onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
} 